import { userContactBookmarkConstants } from '../../constant';

const initialState = {
  contactsData: null,
  contactData: null,
};

export const fetch_user_contacts_reducer = (state = initialState, action) => {
  switch (action.type) {
    case userContactBookmarkConstants.FETCH_USER_CONTACT_ACTION_REQUEST:
      return {
        type: 'alert-success',
        message: action.payload,
      };
    case userContactBookmarkConstants.FETCH_USER_CONTACT_ACTION_SUCCESS:
      return {
        contactsData: action.payload,
      };
    case userContactBookmarkConstants.FETCH_USER_CONTACT_ACTION_FAILURE:
      return {
        type: 'alert-failure',
        error: action.payload,
      };
    

    default:
      return state;
  }
};

export const fetch_user_contact_details_reducer = (state = initialState, action) => {
  switch (action.type) {
    case userContactBookmarkConstants.FETCH_USER_CONTACT_DETAILS_ACTION_REQUEST:
      return {
        type: 'alert-success',
        message: action.payload,
      };
    case userContactBookmarkConstants.FETCH_USER_CONTACT_DETAILS_ACTION_SUCCESS:
    case userContactBookmarkConstants.UPDATE_USER_CONTACT_ACTION_SUCCESS:
      return {
        contactData: action.payload,
      };
    case userContactBookmarkConstants.FETCH_USER_CONTACT_DETAILS_ACTION_FAILURE:
      return {
        type: 'alert-failure',
        error: action.payload,
      };
    default:
      return state;
  }
};

export const fetch_all_admin_contacts_reducer = (state = initialState, action) => {
  switch (action.type) {
    case userContactBookmarkConstants.FETCH_ALL_ADMIN_CONTACTS_ACTION_REQUEST:
      return {
        type: 'alert-success',
        message: action.payload,
      };
    case userContactBookmarkConstants.FETCH_ALL_ADMIN_CONTACTS_ACTION_SUCCESS:
      return {
        allContactsData: action.payload,
      };
    case userContactBookmarkConstants.FETCH_ALL_ADMIN_CONTACTS_ACTION_FAILURE:
      return {
        type: 'alert-failure',
        error: action.payload,
      };
    default:
      return state;
  }
};
